<template>
  <div class="ms-file-upload" :class="isDisabled ? 'isDisabled' : ''">
    <div class="content flex-row" @click="clickInput">
      <slot></slot>
    </div>
    <input type="file" @change="onChange" class="input-upload" ref="inputUpload" :multiple="multiple" :title="title" />
  </div>
</template>
<script>
import {ref} from 'vue';
export default {
  props: {
    modelValue: {
      type: Object,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    allowExten: {
      type: Array,
      default: null,
    },
    allowSize: {
      type: Number,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    //Nếu cần validate thêm những thông tin khác ngoài loại file và size file
    isCustomVallidate: {
      type: Boolean,
      default: false,
    },
    //Xem có cần validate size file hay không
    validateSize: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, {emit}) {
    const inputUpload = ref({});
    const title = ref('');
    const allowExtenDefault = ref(['doc', 'docx', 'xls', 'xlsx', 'pdf']);
    const allowSizeDefault = ref(5);
    /**
     * Sự kiện thay đổi file
     * NCPHUOC 26/07/2022
     */
    const onChange = e => {
      if (e.currentTarget.files.length > 1) {
        let message = validateMultipleFile(e);
        if (!message.content) {
          emit('onMultipleSuccess', e.currentTarget.files);
        } else {
          emit('onMultipleError', message, e.currentTarget.files);
        }
      } else {
        let message = validateFile(e);
        if (!message.content) {
          emit('onSuccess', e.currentTarget.files[0]);
          title.value = e.currentTarget.files[0].name;
        } else {
          emit('onError', message, e.currentTarget.files[0]);
          title.value = '';
        }
      }
      e.currentTarget.value = '';
    };

    /**
     * Click vào ô input
     * NCPHUOC 26/07/2022
     */
    const clickInput = () => {
      inputUpload.value.click();
    };

    /**
     * Validate file đầu vào
     * NCPHUOC 26/07/2022
     */
    const validateFile = e => {
      const file = e.currentTarget.files[0];
      let res = {};
      if (file) {
        if (!validateFileType(file)) {
          res.content = 'Tệp đính kèm không hợp lệ. Vui lòng kiểm tra lại.';
          res.type = 2;
          return res;
        } else if (props.validateSize && !validateSize(file.size)) {
          res.content = 'Tệp đính kèm vượt quá dung lượng cho phép. Vui lòng kiểm tra lại.';
          res.type = 3;
          return res;
        }
        //Nếu cần validate thêm
        else if (props.isCustomVallidate) {
          res.content = 'Cần validate thêm thông tin khác.';
          res.type = 1; //Kiểu validate custom
          return res;
        }
      } else {
        res.content = 'Không tìm thấy file, vui lòng thử lại.';
      }
      return res;
    };

    /**
     * Validate các file được thêm vào
     * DMNGOC 10/10/2022
     */
    const validateMultipleFile = e => {
      const files = e.currentTarget.files;
      let res = {};
      let totalSize = 0;
      if (files) {
        for (let file of files) {
          totalSize += file.size;
        }

        let errorFile = validateFileType(files);
        if (props.validateSize && !validateSize(totalSize)) {
          res.content = 'Tổng dung lượng tệp đính kèm vượt quá dung lượng cho phép. Vui lòng kiểm tra lại';
          res.type = 3;
        } else if (errorFile != null) {
          res.content = 'Tệp đính kèm không hợp lệ. Vui lòng kiểm tra lại';
          res.type = 2;
          res.errorFile = errorFile;
        }
      } else {
        res.content = 'Không tìm thấy file, vui lòng thử lại';
      }
      return res;
    };

    /**
     * Validate loại file được thêm vào
     * NCPHUOC 26/07/2022
     * nxhoa 1.11.2023: cho toLowerCase extention khi kiểm tra
     */
    const validateFileType = file => {
      const allowExt = props.allowExten || allowExtenDefault.value;
      if (file.length > 1) {
        for (let i = 0; i < file.length; i++) {
          const {name} = file[i];
          if (name) {
            const extention = name.split('.').pop();
            if (!allowExt.some(x => x.toLowerCase() === extention.toLowerCase())) {
              return file[i].name;
            }
          }
        }
      } else {
        const {name} = file;

        if (name) {
          const extention = name.split('.').pop();
          if (allowExt.some(x => x.toLowerCase() === extention.toLowerCase())) {
            return true;
          }
        }
      }
    };

    /**
     * Validate size của file
     * NCPHUOC 26/07/2022
     */
    const validateSize = size => {
      const oneMbInBytes = 1024 * 1024;
      let maxSize = props.allowSize || allowSizeDefault.value;
      const maximumFileUpload = maxSize * oneMbInBytes;
      if (size < maximumFileUpload) {
        return true;
      }
    };
    return {
      clickInput,
      inputUpload,
      onChange,
      title,
      allowExtenDefault,
      allowSizeDefault,
    };
  },
};
</script>

<style scoped lang="scss">
.ms-file-upload {
  .input-upload {
    position: absolute;
    opacity: 0;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
  }
  .isDisabled {
    pointer-events: none;
  }
}
</style>
